import firebase from 'firebase/compat/app'
import 'firebase/compat/messaging'
import { useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import { v4 as uuidv4 } from 'uuid'
import AWS from 'aws-sdk'
import { useLocation } from 'react-router-dom'
import { intersection, orderBy } from 'lodash'
import { getCompany_storage, getLocalStorageValue, getUserData } from './storageUtils'
import Payment from 'payment'
import moment from 'moment'
import { store } from 'store/store'
import { addTrafficSource_url, getContents_api } from 'store/apis'
import { htmlToText } from 'html-to-text'

export const CONSTANTS = {
  freeStorage: process.env.REACT_APP_NODE_ENV === 'production' ? 10 * 1024 * 1024 * 1024 : 1 * 5 * 1024 * 1024 /**in Bytes: 1 GB x MB x KB x Bytes  */,
  mainMenuMinWidth: window.innerWidth > 992 ? 250 : window.innerWidth > 576 ? 350 : 320,
  titleMaxLength: 50,
  shortcutMaxLength: 15,
  toolbarDDShadow: '0px 12px 32px rgba(26, 26, 26, 0.2)',
  autosaveTimeoutSecond: 1000,
  draftMentionTimeout: 2000,
  inputPlaceholderText: 'Hover to edit placeholder text',
  updateViewCountTimeout: 3000,
  refreshCommentMarkersTimeout: 500,
  colors: ['#1A1A1A', '#999999', '#CCCCCC', '#EA4949', '#ED9E28', '#F3C73F', '#106DEB', '#1DA055', '#51C1BB', '#B87914', '#D96BC7', '#9A4AEA'],
  backgrounds: ['#EFEFEF', '#FFE3E3', '#FFE7C2', '#FFF3C9', '#FCE1F4', '#E0EBFF', '#DCF5E4', '#D0F3F5', '#F0DCC9', '#E9D9FF']
}

const s3 = new AWS.S3({
  endpoint: process.env.REACT_APP_DO_SPACES_endpoint,
  accessKeyId: process.env.REACT_APP_DO_SPACES_access,
  secretAccessKey: process.env.REACT_APP_DO_SPACES_secret
})

export const FCM_cred = {
  apiKey: process.env.REACT_APP_FCM_apiKey,
  authDomain: process.env.REACT_APP_FCM_authDomain,
  projectId: process.env.REACT_APP_FCM_projectId,
  storageBucket: process.env.REACT_APP_FCM_storageBucket,
  messagingSenderId: process.env.REACT_APP_FCM_messagingSenderId,
  appId: process.env.REACT_APP_FCM_appId
}

export const getFirebase = () => {
  try {
    // Initialize Firebase
    if (!firebase.apps.length) {
      firebase.initializeApp(FCM_cred)
      // const messaging = firebase.messaging()
      // messaging.usePublicVapidKey(process.env.REACT_APP_FCM_VAPID_KEY)
    }
    return {
      firebase
    }
  } catch (error) { }
}

// Push Notification
export const getToken = (messaging) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (Notification.permission !== 'denied') {
        const currentToken = await messaging.getToken({ vapidKey: process.env.REACT_APP_FCM_VAPID_KEY })
        if (currentToken) {
          resolve(currentToken)
        } else {
          reject()
        }
      } else {
        reject()
      }
    } catch (error) {
      reject(error)
    }
  })
}
// End. Push notification

export const uniqueRows = (old_data, new_data) => {
  const data = [...old_data]
  const old_ids = old_data.map((d) => d.id)
  for (const row of new_data) {
    if (old_ids.indexOf(row.id) === -1) {
      data.push(row)
    }
  }
  return data
}

export const getAllDraftsList = (data) => {
  const { my_drafts, shared_drafts } = data
  const drafts = [...my_drafts, ...shared_drafts]
  return drafts
}

export const generateBreadcrumb = (category, breadbrumb, page) => {
  breadbrumb.unshift(category)
  if (category.parent_category) {
    generateBreadcrumb(category.parent_category, breadbrumb, page)
  }
  return breadbrumb
}

export const sharing_access = {
  owner: 1,
  editor: 2,
  viewer: 3,
  1: 'owner',
  2: 'editor',
  3: 'viewer'
}
export const RESTRICTED_CATEGORY_NAMES = ['private', 'drafts', 'shared with me', 'my drafts', 'shared drafts']

export const version_titles = {
  updated: 'Updated',
  created: 'Created',
  restored: 'Version Restored'
}
export const usePrevious = (value) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}

// Start: Placeholders
var save
const saveContent = () => {
  if (save) {
    save()
  }
}
const textPlaceholderHandler = (e) => {
  const parentWrapper = e.target.closest('.text-placeholder-wrapper')
  if (parentWrapper) {
    const textContent = e.target.textContent.replace(/\u200B/g, '')
    if (textContent) {
      parentWrapper.attributes['data-length'].value = textContent
      parentWrapper.classList.add('has-text')
    } else {
      parentWrapper.classList.remove('has-text')
      parentWrapper.attributes['data-length'].value = parentWrapper.attributes['data-placeholdertext'].value
    }
  }
  saveContent()
}

export const removePlaceholderHandler = (e) => {
  e.preventDefault()
  e.stopPropagation()
  const parentWraper = e.target.closest('.placeholder-wrapper')
  if (parentWraper) {
    if (parentWraper.parentNode) parentWraper.parentNode.insertBefore(document.createElement('br'), parentWraper.nextSibling)
    parentWraper.remove()
  }
  saveContent()
}

const uploadFileHandler = async (e) => {
  if (e.target.files.length > 0) {
    try {
      const file = e.target.files[0]
      if (file && validateFreeStorageAccess(file.size)) {
        const fullFilename = file.name.split('.')
        const fileExtension = fullFilename.pop()
        const params = {
          ACL: 'public-read',
          Body: file,
          Bucket: process.env.REACT_APP_DO_SPACES_bucket,
          Key: `${process.env.REACT_APP_DO_SPACES_EDITOR}${company_id}/${uuidv4()}.${fileExtension}`
        }
        s3.putObject(params, () => {
          const link = `${process.env.REACT_APP_DO_SPACES_BUCKET_URL}${params.Key}`
          const parentWraper = e.target.closest('.file-placeholder-wrapper')
          if (parentWraper) {
            parentWraper.classList.add('uploaded')
            if (parentWraper.classList.contains('image')) {
              const div = document.createElement('div')
              div.classList.add('file-uploaded')
              div.innerHTML = `<img src='${link}' class='image'/>`
              parentWraper.appendChild(div)
            } else if (parentWraper.classList.contains('video')) {
              const div = document.createElement('div')
              div.classList.add('file-uploaded')
              div.innerHTML = `<span class="fr-video fr-dvb fr-draggable" contenteditable="false" draggable="true"><video class="video fr-draggable" data-name="${file.name}" controls src='${link}'></video></span>`
              parentWraper.appendChild(div)
            } else if (parentWraper.classList.contains('file-link')) {
              const div = document.createElement('div')
              div.classList.add('file-uploaded')
              div.innerHTML = `<a class="file-link" href='${link}' target="_blank" rel="noopener noreferrer"><img src='${process.env.REACT_APP_DO_SPACES_BUCKET_URL}editor/embedded_items/draft_page.svg' /><div class='file-name'>${file.name}</div></a>`
              parentWraper.appendChild(div)
            } else if (parentWraper.querySelector('.file-uploaded .image')) {
              parentWraper.querySelector('.file-uploaded .image').src = link
            } else if (parentWraper.querySelector('.file-uploaded .video')) {
              parentWraper.querySelector('.file-uploaded .video').src = link
            } else if (parentWraper.querySelector('.file-uploaded .file-link')) {
              parentWraper.querySelector('.file-uploaded .file-link').href = link
              parentWraper.querySelector('.file-uploaded .file-link .file-name').textContent = file.name
            }
          }
          saveContent()
          initPlaceholderEdit(save)
        })
      }
    } catch (error) {
      handleApiError(error)
    }
  }
}

var srcElement, actionButtonTimeout
const handleMouseMove = (e) => {
  srcElement = e.srcElement
}
document.onmousemove = handleMouseMove
const actionPopupLeave = (e) => {
  e.target.removeEventListener('mouseleave', actionPopupLeave)
  if (!srcElement.classList.contains('placeholder-wrapper') && !srcElement.closest('.placeholder-wrapper')) {
    e.target.innerHTML = ''
    e.target.removeAttribute('hovered-uuid')
    e.target.style.display = 'none'
  }
}
// Text Placeholder Action
const placeholderWrapperLeave = () => {
  const actionPopup = document.querySelector('.placeholder-action-popup')
  if (actionPopup) {
    actionPopup.removeEventListener('mouseleave', actionPopupLeave)
    actionPopup.addEventListener('mouseleave', actionPopupLeave)
  }
  if (actionPopup) {
    clearTimeout(actionButtonTimeout)
    actionButtonTimeout = setTimeout(() => {
      if (!srcElement.classList.contains('action-button') && !srcElement.closest('.action-button')) {
        actionPopup.removeAttribute('hovered-uuid')
        actionPopup.style.display = 'none'
      }
    }, 400)
  }
}

// Text Placeholder Action Popup
const addTextPlaceholderActionButtons = (e) => {
  let placeholderWrapper = e.target
  if (!placeholderWrapper.classList.contains('placeholder-wrapper')) {
    placeholderWrapper = placeholderWrapper.closest('.placeholder-wrapper')
  }

  placeholderWrapper.removeEventListener('mouseleave', placeholderWrapperLeave)
  placeholderWrapper.addEventListener('mouseleave', placeholderWrapperLeave)

  const actionPopup = document.querySelector('.placeholder-action-popup')
  if (actionPopup) {
    actionPopup.style.display = 'flex'

    const pos = placeholderWrapper.getBoundingClientRect()
    actionPopup.style.top = `${pos.y + placeholderWrapper.offsetHeight}px`
    actionPopup.style.left = `${pos.x + placeholderWrapper.offsetWidth / 2 - actionPopup.offsetWidth / 2}px`
    actionPopup.setAttribute('hovered-uuid', placeholderWrapper.attributes['data-placeholder-id'].value)

    let innerHTML = ''
    if (!placeholderWrapper.classList.contains('embedded-page')) {
      // For Text placeholder
      innerHTML = `${innerHTML}<span class='action-button edit-placeholder' title="Edit placeholder text"> <img src='${process.env.REACT_APP_DO_SPACES_BUCKET_URL}editor/embedded_items/edit.svg' /></span>`
      innerHTML = `${innerHTML}<div class='placeholder-form d-none'><input type='text' class='form-control placeholder-text' /></div>`
    } else {
      // For Embedded published page
      const uuid = placeholderWrapper.attributes['data-embedded-content-uuid'].value
      innerHTML = `${innerHTML}<a href='/page/${uuid}' target='_blank' rel='noreferrer' class='action-button' title="Open in new tab"> <img src='${process.env.REACT_APP_DO_SPACES_BUCKET_URL}editor/embedded_items/edit.svg' /></a>`
    }
    innerHTML = `${innerHTML}<span class='action-button remove-file-popup' title="Delete (Ctrl + Backspace)"> <img src='${process.env.REACT_APP_DO_SPACES_BUCKET_URL}editor/embedded_items/trash.svg' /></span>`
    actionPopup.innerHTML = innerHTML

    actionPopup.querySelector('.remove-file-popup').addEventListener('click', () => {
      const placeholderID = actionPopup.attributes['hovered-uuid'].value
      const parentWraper = document.querySelector(`.text-placeholder-wrapper[data-placeholder-id="${placeholderID}"]`)
      if (parentWraper) {
        parentWraper.remove()
        actionPopup.removeAttribute('hovered-uuid')
        actionPopup.style.display = 'none'
      }
      saveContent()
    })
  }

  // For Text placeholder
  if (!placeholderWrapper.classList.contains('embedded-page')) {
    actionPopup.querySelector('.edit-placeholder').addEventListener('click', (el) => {
      const placeholderID = actionPopup.attributes['hovered-uuid'].value
      const placeholderWrapper = document.querySelector(`.text-placeholder-wrapper[data-placeholder-id="${placeholderID}"]`)
      if (placeholderWrapper) {
        actionPopup.querySelectorAll('.action-button').forEach((_button) => _button.classList.toggle('d-none'))
        actionPopup.querySelector('.placeholder-form').classList.toggle('d-none')
        const INPUT = actionPopup.querySelector('.placeholder-form input')
        INPUT.value = placeholderWrapper.attributes['data-placeholdertext'].value
        INPUT.focus()
        INPUT.addEventListener('keyup', (input) => {
          placeholderWrapper.attributes['data-placeholdertext'].value = input.target.value.trim() || CONSTANTS.inputPlaceholderText
          placeholderWrapper.attributes['data-length'].value = input.target.value.trim() || CONSTANTS.inputPlaceholderText
        })
      }
    })
  }
}

// Image/Video/File Placeholder Action Popup
const addFilePlaceholderActionButtons = (e) => {
  let placeholderWrapper = e.target
  if (!placeholderWrapper.classList.contains('placeholder-wrapper')) {
    placeholderWrapper = placeholderWrapper.closest('.placeholder-wrapper')
  }
  const fileUploaded = placeholderWrapper.querySelector('.file-uploaded')

  fileUploaded.removeEventListener('mouseleave', placeholderWrapperLeave)
  fileUploaded.addEventListener('mouseleave', placeholderWrapperLeave)

  const actionPopup = document.querySelector('.placeholder-action-popup')
  if (actionPopup) {
    actionPopup.style.display = 'flex'
    const pos = fileUploaded.getBoundingClientRect()
    actionPopup.style.top = `${pos.y + fileUploaded.offsetHeight - 10}px`
    actionPopup.style.left = `${pos.x + fileUploaded.offsetWidth / 2 - actionPopup.offsetWidth / 2}px`
    actionPopup.setAttribute('hovered-uuid', placeholderWrapper.attributes['data-placeholder-id'].value)

    actionPopup.innerHTML = `<span class='action-button remove-file-popup' title="delete"> <img src='${process.env.REACT_APP_DO_SPACES_BUCKET_URL}editor/embedded_items/trash.svg' /></span>`

    actionPopup.querySelector('.remove-file-popup').addEventListener('click', () => {
      const placeholderID = actionPopup.attributes['hovered-uuid'].value
      const _placeholderWrapper = document.querySelector(`.file-placeholder-wrapper[data-placeholder-id="${placeholderID}"]`)
      if (_placeholderWrapper) {
        const fileElement = _placeholderWrapper.querySelector('.file-uploaded [src*="editor/"], .file-uploaded [href*="editor/"]')
        if (fileElement) {
          const removingLink = fileElement.href || fileElement.src
          removeMediaFromSpaces(removingLink)
        }

        _placeholderWrapper.querySelector('.file-uploaded').remove()

        if (_placeholderWrapper.querySelector('input[type="file"]')) {
          _placeholderWrapper.querySelector('input[type="file"]').value = ''
          _placeholderWrapper.classList.remove('uploaded')
        }

        actionPopup.removeAttribute('hovered-uuid')
        actionPopup.style.display = 'none'
        saveContent()
      }
    })
  }
}

const initColorCodeValidation = (e) => {
  if (e.key !== 'Backspace' && (e.key === 'Enter' || e.target.textContent.length === 6 || !/[0-9A-F]/gi.test(e.key))) {
    e.preventDefault()
  }
}

// Init Placeholders
export const initPlaceholderEdit = (_save) => {
  save = _save

  const EDITOR_TEXT_PLACEHOLDERS = document.querySelectorAll('.text-placeholder')
  EDITOR_TEXT_PLACEHOLDERS.forEach((placeholder) => {
    if (placeholder.closest('.published-page')) {
      if (!placeholder.textContent.trim()) {
        placeholder.closest('.text-placeholder-wrapper').classList.remove('has-text')
      } else {
        placeholder.closest('.text-placeholder-wrapper').classList.add('has-text')
      }
      saveContent()
    }
    placeholder.removeEventListener('keyup', textPlaceholderHandler)
    placeholder.addEventListener('keyup', textPlaceholderHandler)
  })

  // Placeholder remover
  if (!window.location.href.includes('drafts/edit')) {
    const fileRemovers = document.querySelectorAll('.placeholder-wrapper .file-uploaded')
    fileRemovers.forEach((el) => {
      el.removeEventListener('mousemove', addFilePlaceholderActionButtons)
      el.addEventListener('mousemove', addFilePlaceholderActionButtons)
    })
  }

  const textPlaceholders = document.querySelectorAll('.text-placeholder-wrapper')
  textPlaceholders.forEach((el) => {
    el.removeEventListener('mousemove', addTextPlaceholderActionButtons)
    el.addEventListener('mousemove', addTextPlaceholderActionButtons)
  })

  // Uploaded placeholder image/video/file remover
  const filePlaceholderRemovers = document.querySelectorAll('.placeholder-wrapper .remove-placeholder')
  filePlaceholderRemovers.forEach((el) => {
    el.removeEventListener('click', removePlaceholderHandler)
    el.addEventListener('click', removePlaceholderHandler)
  })

  const filePlaceholderInputs = document.querySelectorAll('.placeholder-wrapper input[type="file"]')
  filePlaceholderInputs.forEach((el) => {
    el.removeEventListener('change', uploadFileHandler)
    el.addEventListener('change', uploadFileHandler)
  })

  let initColorHexInput = setInterval(() => {
    const textColorHexInput = document.querySelector('#textColorHexInput')
    if (textColorHexInput) {
      clearInterval(initColorHexInput)
      textColorHexInput.removeEventListener('keydown', initColorCodeValidation)
      textColorHexInput.addEventListener('keydown', initColorCodeValidation)
    }
  }, 1000)
}
// End: Placeholders

export const handleApiError = (error) => {
  if (error) {
    consoleLog(error)
    if (error._errors) {
      const errors = error._errors.reduce((prevVal, newVal) => `${prevVal}<br/>${newVal}`)
      toast.error(errors)
    } else if (error.message) {
      toast.error(error.message)
    } else {
      toast.error(error)
    }
  }
}

export const removePopupsBeforeSave = (content) => {
  const div = document.createElement('div')
  div.innerHTML = content
  for (const e of div.querySelectorAll('.placeholder-action-popup')) {
    e.remove()
  }
  for (const e of div.querySelectorAll('.comment-button-icon')) {
    e.remove()
  }

  // Remove contenteditables if content copy/pasted from other source. Only keep our own.
  const allContentEditables = div.querySelectorAll('[contenteditable]')
  for (const e of allContentEditables) {
    const ignoreElements = ['embedded-content', 'placeholder-wrapper', 'text-placeholder', 'callout-item', 'fr-video']
    if (!e.classList.value || intersection(ignoreElements, e.classList.value.split(' ')).length === 0) {
      e.removeAttribute('contenteditable')
    }
  }
  return div.innerHTML
}

export const copyLink = (content) => {
  if (content.type === 'page') {
    if (content.is_draft) {
      navigator.clipboard.writeText(`${process.env.REACT_APP_BASE_URL}pages/drafts/edit/${generateSlug(content)}`)
    } else {
      navigator.clipboard.writeText(`${process.env.REACT_APP_BASE_URL}page/${generateSlug(content)}`)
    }
  } else {
    navigator.clipboard.writeText(`${process.env.REACT_APP_BASE_URL}response/${generateSlug(content)}`)
  }
}

export const shareLink = (title, uuid) => {
  navigator.clipboard.writeText(`${process.env.REACT_APP_BASE_URL}guest/page/${generateGuestSlug(title, uuid)}`)
}

export var curr_range = null
export const initCommentButton = (e) => {
  const selection = window.getSelection()
  if (!selection.isCollapsed) {
    const parentNode = selection.focusNode.parentNode
    const baseNode = selection.baseNode || selection.anchorNode
    const focusNode = selection.focusNode || selection.extentNode
    if (parentNode && parentNode.closest('.content-wrapper .fr-view')) {
      const COMMENT_BUTTON = document.querySelector('.comment-button-icon')
      if (baseNode === focusNode && !selection.isCollapsed && parentNode.classList && !parentNode.classList.contains('text-placeholder')) {
        if (COMMENT_BUTTON) {
          COMMENT_BUTTON.style.left = `${e.clientX - 10}px`
          COMMENT_BUTTON.style.top = `${e.clientY + 10}px`
          COMMENT_BUTTON.classList.add('show')
          curr_range = selection.getRangeAt(0)

          setTimeout(() => {
            document.addEventListener('click', hideCommentButton)
          }, 100)
        }
      } else {
        if (COMMENT_BUTTON) COMMENT_BUTTON.classList.remove('show')
        curr_range = null
      }
    }
  }
}
export const hideCommentButton = () => {
  document.removeEventListener('click', hideCommentButton)
  const COMMENT_BUTTON = document.querySelector('.comment-button-icon')
  if (COMMENT_BUTTON) COMMENT_BUTTON.classList.remove('show')
}

export const updateHighlightSelection = () => {
  document.querySelectorAll('.comment-marker').forEach((e) => {
    if (!e.hasAttribute('data-comment-uuid')) {
      // If comment not added, remove comment-marker span.
      e.outerHTML = e.innerHTML
    } else {
      // If comment added, only remove has-annotation_open
      e.classList.remove('has-annotation_open')
    }
  })
}

export const openCommentsDrawer = (e, set_commentUUID, set_showControlPanel, set_expandedTab) => {
  e.stopImmediatePropagation()
  if (e.target.attributes['data-comment-uuid']) {
    set_commentUUID(e.target.attributes['data-comment-uuid'].value)
    set_showControlPanel(true)
    set_expandedTab('comments')
  }
}

export const updateCommentMarkers = (commentUUID, page, updateLivePage, editor, set_content, set_editDraft) => {
  const frView = document.querySelector('.content-wrapper .fr-view')
  const e = frView.querySelector(`.comment-uuid-${commentUUID}`)
  if (e) {
    e.setAttribute('data-comment-uuid', `${commentUUID}`)
    e.classList.add('has-annotation')
    e.classList.remove('has-annotation_open')
    if (updateLivePage) {
      updateLivePage(frView.innerHTML, page.uuid)
    }
    if (editor && set_content && set_editDraft) {
      const _content = editor.html.get()
      set_content(_content)
      set_editDraft((values) => ({ ...values, content: _content }))
    }
  }
}

export const onCommentButtonClick = (e, user, set_commentUUID, set_expandedTab, set_showControlPanel) => {
  e.stopPropagation()
  const COMMENT_BUTTON = document.querySelector('.comment-button-icon')
  COMMENT_BUTTON.classList.remove('show')
  let uuid
  if (curr_range) {
    for (const classname of curr_range.endContainer.parentNode.classList) {
      if (classname.includes('comment-uuid-')) {
        uuid = classname.replace('comment-uuid-', '')
      }
    }
    if (!uuid) {
      uuid = `${user.id}-${uuidv4()}`
      const selected_text = curr_range.toString()
      const commentMarker = document.createElement('span')
      commentMarker.textContent = selected_text
      commentMarker.classList.add('has-annotation_open')
      commentMarker.classList.add(`comment-marker`)
      commentMarker.classList.add(`comment-uuid-${uuid}`)
      curr_range.deleteContents()
      curr_range.insertNode(commentMarker)
    } else {
      curr_range.endContainer.parentNode.classList.add('has-annotation_open')
    }
    set_commentUUID(uuid)
    set_expandedTab('comments')
    set_showControlPanel(true)
  }
}

export const getCompanyPermissionObject = (company) => ({
  id: company.id,
  uuid: company.uuid,
  owner_id: company.owner_id,
  name: `Everyone`,
  value: '_everyone_',
  option_type: 'company',
  avatar: company.logo
})

export const getTeamPermissionObject = (all_teams) => {
  return all_teams.map((team) => ({
    ...team,
    team_id: team.id,
    name: `Team: ${team.name}`,
    value: team.uuid,
    option_type: 'team'
  }))
}

export const handleNotificationScroll = async (e, type, getNotifications, set_notification_loading) => {
  set_notification_loading(true)
  if (Math.ceil(e.target.offsetHeight + e.target.scrollTop) >= e.target.scrollHeight) {
    await getNotifications({ type })
    set_notification_loading(false)
  }
}

// DO SPACES
export const uploadFromEditor = (uploadType, file, editor) => {
  if (s3) {
    try {
      const fullFilename = file.name.split('.')
      const fileExtension = fullFilename.pop()
      const params = {
        ACL: 'public-read',
        Body: file,
        Bucket: process.env.REACT_APP_DO_SPACES_bucket,
        Key: `${process.env.REACT_APP_DO_SPACES_EDITOR}${company_id}/${uuidv4()}.${fileExtension}`
      }
      s3.putObject(params, (err) => {
        if (!err) {
          if (uploadType === 'image') {
            const image = editor.image.get()
            if (image && image[0]) {
              image[0].src = `${process.env.REACT_APP_DO_SPACES_BUCKET_URL}${params.Key}`
            } else {
              editor.image.insert(`${process.env.REACT_APP_DO_SPACES_BUCKET_URL}${params.Key}`)
            }
          } else if (uploadType === 'file') {
            editor.file.insert(`${process.env.REACT_APP_DO_SPACES_BUCKET_URL}${params.Key}`, file.name, { link: `${process.env.REACT_APP_DO_SPACES_BUCKET_URL}${params.Key}` })
          } else if (uploadType === 'video') {
            const videospan = editor.video.get()
            if (videospan && videospan[0]?.querySelector('video')) {
              videospan[0].querySelector('video').src = `${process.env.REACT_APP_DO_SPACES_BUCKET_URL}${params.Key}`
            } else {
              editor.html.insert(
                `<span contenteditable="false" draggable="true" class="fr-video fr-dvb fr-draggable"><video data-name='${file.name}' src='${process.env.REACT_APP_DO_SPACES_BUCKET_URL}${params.Key}' controls>Your browser does not support HTML5 video.</video></span>`
              )
            }
          }
        }
      })
    } catch (error) {
      handleApiError(error)
    }
  }
}

export const removeMediaFromSpaces = (link) => {
  if (link) {
    try {
      const Key = link.replace(process.env.REACT_APP_DO_SPACES_BUCKET_URL, '')
      if (Key && s3) {
        s3.deleteObject({ Bucket: process.env.REACT_APP_DO_SPACES_bucket, Key }, (err) => handleApiError(err))
      }
    } catch (error) {
      handleApiError(error)
    }
  }
}

export const getCompanyStorageSize = async (company_id) => {
  try {
    var totalSize = 0,
      ContinuationToken
    do {
      var resp = await s3
        .listObjectsV2({
          Bucket: process.env.REACT_APP_DO_SPACES_bucket,
          Prefix: `${process.env.REACT_APP_DO_SPACES_EDITOR}${company_id}/`,
          ContinuationToken
        })
        .promise()
        .catch((error) => {
          consoleLog(error)
        })
      for (const content of resp.Contents) {
        totalSize += content.Size
      }
      ContinuationToken = resp.NextContinuationToken
    } while (ContinuationToken)

    return totalSize
  } catch (error) {
    consoleLog(error)
  }
}

export const uploadtoSpaces = (folder, file) => {
  return new Promise((resolve, reject) => {
    try {
      const fullFilename = file.name.split('.')
      const fileExtension = fullFilename.pop()
      const params = {
        ACL: 'public-read',
        Body: file,
        Bucket: process.env.REACT_APP_DO_SPACES_bucket,
        Key: `${folder}${uuidv4()}.${fileExtension}`
      }
      s3.putObject(params, (err, data) => {
        if (!err) {
          resolve(`${process.env.REACT_APP_DO_SPACES_BUCKET_URL}${params.Key}`)
        } else {
          reject(err)
          throw err
        }
      })
    } catch (error) {
      handleApiError(error)
    }
  })
}

let company_id = null
let companyStorageUtilized = 0
let isFree = false
let is_subscribed = false
let isOnGracePeriod = false
export const setCompanyStorageUtilization_helpers = (company, _isFree, _isOnGracePeriod, _is_subscribed) => {
  company_id = company.id
  companyStorageUtilized = company.storageUtilized
  is_subscribed = _is_subscribed
  isFree = _isFree
  isOnGracePeriod = _isOnGracePeriod
}

export const validateFreeStorageAccess = (file_size) => {
  if (!isFree && !isOnGracePeriod && !is_subscribed && companyStorageUtilized + file_size > CONSTANTS.freeStorage) {
    handleApiError(<>You've reached the file storage limit. Please upgrade your plan</>)
    return false
  }
  return true
}

// End.DO SPACES

export const getOS = () => {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'MacOS'
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS'
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows'
  } else if (/Android/.test(userAgent)) {
    os = 'Android'
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux'
  }
  return os
}

export const validateForm = (title, content) => {
  let is_valid = true
  const div = document.createElement('div')
  div.innerHTML = content
  const plain_content = (div.textContent || div.innerText || '')?.trim() || ''
  if (!(title || '').trim() || title?.length > CONSTANTS.titleMaxLength || (!plain_content && !content?.includes('img') && !content?.includes('video'))) {
    is_valid = false
  }
  div.remove()
  return is_valid
}

export const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export const checkUser_for_admin_or_owner = (row, user) => {
  return (user.membership && user.membership.user_type === 'admin') || row.user_id === user.id || (row.access && row.access === sharing_access.owner)
}
export const checkUser_for_admin_or_owner_or_editor = (row, user) => {
  return (user.membership && user.membership.user_type === 'admin') || row.user_id === user.id || (row.access && row.access !== sharing_access.viewer)
}
export const checkUser_for_admin_or_viewer = (row, user) => {
  return row.user_id !== user.id && row.access && row.access === sharing_access.viewer
}

export const logAmplitudeEvent = (event, data = {}) => {
  if (window.amplitude && process.env.REACT_APP_NODE_ENV === 'production') {
    const user = getUserData()
    if (user) {
      data.email = user.email
    }
    const company = getCompany_storage()
    if (company) {
      data.company = company.name
    }
    window.amplitude.getInstance().logEvent(event, data)
  }
}

export const getAllTeams = (teams) => {
  const myTeamsIds = teams.myTeams.map((t) => t.id)
  return orderBy([...teams.myTeams, ...teams.sharedTeams.filter((t) => myTeamsIds.indexOf(t.id) === -1), ...teams.nonParticipatingTeams], (t) => t.name, 'asc')
}

export const emptyCache = () => {
  if ('caches' in window) {
    caches.keys().then((names) => {
      for (const name of names) {
        caches.delete(name)
      }
      window.location.reload(true)
    })
  }
}

export const uuidExtract = (url) => {
  const urlParts = url.split('-')
  return urlParts.pop()
}

const url_slug = (str) => {
  str = str.replace(/^\s+|\s+$/g, '') // trim
  str = str.toLowerCase()
  // remove accents, swap ñ for n, etc
  var from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;'
  var to = 'aaaaaeeeeiiiioooouuuunc------'

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
  }
  str = str
    .replace(/\)+/g, '-')
    .replace(/\(+/g, '-')
    .replace(/\*+/g, '-')
    .replace(/\^+/g, '-')
    .replace(/%+/g, '-')
    .replace(/\$+/g, '-')
    .replace(/#+/g, '-')
    .replace(/`+/g, '-')
    .replace(/~+/g, '-')
    .replace(/!+/g, '-')
    .replace(/@+/g, '-')
    .replace(/&+/g, '-')
    .replace(/\++/g, '-')
    .replace(/\{+/g, '-')
    .replace(/\}+/g, '-')
    .replace(/\[+/g, '-')
    .replace(/\]+/g, '-')
    .replace(/\\+/g, '-')
    .replace(/\/+/g, '-')
    .replace(/:+/g, '-')
    .replace(/"+/g, '-')
    .replace(/'+/g, '-')
    .replace(/>+/g, '-')
    .replace(/<+/g, '-')
    .replace(/,+/g, '-')
    .replace(/\.+/g, '-')
    .replace(/=+/g, '-')
    .replace(/\?+/g, '-')
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-') // collapse dashes
  return str
}
export const generateSlug = (content) => {
  if (getTitle(content.title)) {
    return `${url_slug(getTitle(content.title))}--${content.uuid}`
  } else {
    return content.uuid
  }
}

export const generateGuestSlug = (title, uuid) => {
  return `${url_slug(getTitle(title))}--${uuid}`
}

// Payment Method
function clearNumber(value = '') {
  return value.replace(/\D+/g, '')
}
export function formatCreditCardNumber(value) {
  if (!value) {
    return value
  }

  const issuer = Payment.fns.cardType(value)
  const clearValue = clearNumber(value)
  let nextValue
  switch (issuer) {
    case 'amex':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10)} ${clearValue.slice(10, 15)}`
      break
    case 'dinersclub':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10)} ${clearValue.slice(10, 14)}`
      break
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 8)} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 16)}`
      break
  }

  return nextValue.trim()
}
export function formatCVC(value, prevValue, allValues = {}) {
  const clearValue = clearNumber(value)
  let maxLength = 3
  return clearValue.slice(0, maxLength)
}
export function formatExpirationDate(value) {
  const clearValue = clearNumber(value)

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`
  }

  return clearValue
}

export function getCreditAmount(subscription) {
  const totalSeconds = subscription.current_period_end - subscription.current_period_start
  const secondsSpent = (moment().valueOf() - moment.utc(moment.unix(subscription.current_period_start)).local().valueOf()) / 1000
  const secondsLeft = totalSeconds - secondsSpent

  const totalAmountPaid = subscription.last_amount_paid ? subscription.last_amount_paid / 100 : 0
  const costPerSecond = totalAmountPaid / totalSeconds
  return (secondsLeft * costPerSecond).toFixed(2)
}

export const copyTextHandler = async (type, response) => {
  let plain_content = response.content
  plain_content = htmlToText(plain_content, {
    wordwrap: false,
    selectors: [
      { selector: 'blockquote', format: 'skip' },
      { selector: 'img', format: 'skip' },
      { selector: 'br', format: 'skip' },
      {
        selector: 'a',
        options: {
          linkBrackets: false,
          ignoreHref: true
        }
      },
      {
        selector: 'div',
        options: {
          leadingLineBreaks: 0,
          trailingLineBreaks: 0
        }
      },
      {
        selector: 'p',
        options: {
          leadingLineBreaks: 0,
          trailingLineBreaks: 0
        }
      }
    ]
  })
  plain_content = plain_content.replace(/\n\n/gi, '\n')
  const listener = (e) => {
    if (type === 'plain') {
      e.clipboardData.setData('text/plain', plain_content)
    } else {
      e.clipboardData.setData('text/html', response.content)
      e.clipboardData.setData('text/plain', plain_content)
    }
    e.preventDefault()
  }
  document.addEventListener('copy', listener)
  document.execCommand('copy')
  document.removeEventListener('copy', listener)
  return Promise.resolve()
}

export const checkIsOnGracePeriod = (isOnGracePeriod, subscription) => isOnGracePeriod && (!subscription.id || subscription.cancelled_subscriptions === 0)

export const getDiscountedPrice = (plan_selected, isOnGracePeriod, subscription) => {
  const plan_amount = plan_selected.amount / 100
  let final_amount = plan_amount
  if (checkIsOnGracePeriod(isOnGracePeriod, subscription)) {
    final_amount = final_amount - final_amount * 0.2
  }
  return final_amount
}

export const getRootCategory = (category, rootCategory = {}) => {
  rootCategory = category
  if (rootCategory.parent_category) {
    rootCategory = getRootCategory(rootCategory.parent_category)
  }
  const {
    contents: { pages, responses }
  } = store.getState()
  const allCategories = [...pages.shared_categories, ...pages.private_categories, ...responses.shared_categories, ...responses.private_categories]
  const i = allCategories.findIndex((c) => c.id === rootCategory.id)
  if (i !== -1) {
    return allCategories[i]
  }
  return {}
}

export const allCategoryIds = (categories) => {
  const _allCategoryIds = []
  for (const cat of categories) {
    _allCategoryIds.push(cat.id)
    for (const sub_cat of cat.subcategories) {
      _allCategoryIds.push(sub_cat.id)
      for (const sub_sub_cat of sub_cat.subcategories) {
        _allCategoryIds.push(sub_sub_cat.id)
      }
    }
  }
  return _allCategoryIds
}

export const addTrafficSource = async (action, company_name = '', email = '') => {
  try {
    const traffic_source = await getLocalStorageValue('traffic_source')
    if (traffic_source) {
      const trafficData = JSON.parse(traffic_source)
      trafficData.email = email
      trafficData.company_name = company_name
      trafficData.action = action
      await addTrafficSource_url(trafficData)
    }
  } catch (error) {
    consoleLog(error)
  }
}

export const checkImageUploadType = (fileType) => {
  return ['image/png', 'image/jpg', 'image/jpeg'].includes(fileType)
}

export const isZoom = () => {
  const userAgent = window.navigator.userAgent
  return userAgent?.toLowerCase().includes('zoom')
}
export const getTarget = () => {
  const userAgent = window.navigator.userAgent
  return userAgent?.toLowerCase().includes('zoom') ? '_top' : '_blank'
}
export const handleExternalLink = (e) => {
  if (isZoom()) {
    e.preventDefault()
    let element = e.target
    if (element.nodeName.toLowerCase() !== 'a') {
      element = element.closest('a')
    }
    openUrlFromZoom(element.href)
  }
}

export const openUrlFromZoom = (url) => {
  if (window.zoomSdk) {
    window.zoomSdk.openUrl({ url })
  }
}

export const makeFroalaDivAflexBox = () => {
  const divSelectors = window.document.querySelectorAll('.fr-basic .fr-element div');
  divSelectors.forEach(divSelector => {
    divSelector && (divSelector.style.display = 'block')
    // if (divSelector && divSelector.innerHTML !== '' && divSelector.innerHTML !== '<br>' && !/^\u200B*$/.test(divSelector.innerHTML)) {
    //   divSelector && (divSelector.style.display = 'flex')
    // } else {
    //   divSelector && (divSelector.style.display = 'block')
    // }
  })
}
export const prepareSearchedContents = async (search, _preExpanded = []) => {
  const contents = await getContents_api({ search, type: 'response' })
  const _uncategorized_private_contents = contents.filter((item) => !item.category_id)
  if (_uncategorized_private_contents.length) {
    _preExpanded.push('private')
  }

  const categorized_contents = contents.filter((item) => item.category_id)
  let rootCategories = []
  for (const content of categorized_contents) {
    if (content.category?.parent_category?.parent_category) {
      const i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.parent_category?.id)
      if (i === -1) {
        rootCategories.push({
          ...content.category?.parent_category?.parent_category,
          contents: [],
          subcategories: []
        })
      }
    } else if (content.category?.parent_category) {
      const i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.id)
      if (i === -1) {
        rootCategories.push({
          ...content.category?.parent_category,
          contents: [],
          subcategories: []
        })
      }
    } else if (content.category) {
      const i = rootCategories.findIndex((cat) => cat.id === content.category?.id)
      if (i === -1) {
        rootCategories.push({
          ...content.category,
          contents: [],
          subcategories: []
        })
      }
    }

    // Check content.category is a root category
    const i = rootCategories.findIndex((cat) => cat.id === content.category?.id)
    if (i !== -1) {
      rootCategories[i].contents.push(content)
      _preExpanded.push(`cat_${content.category?.uuid}`)
    } else {
      // If NOT content.category is a root category
      // Check if content.category.parent_category is a root category
      const root_i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.id)
      if (root_i !== -1) {
        // If root category found, then find the subcategory for content.category.parent_category
        const sub_cat_i = rootCategories[root_i].subcategories.findIndex((cat) => cat.id === content.category?.id)
        if (sub_cat_i !== -1) {
          rootCategories[root_i].subcategories[sub_cat_i].contents.push(content)
          _preExpanded.push(`cat_${rootCategories[root_i]?.uuid}`)
          _preExpanded.push(`cat_${rootCategories[root_i]?.subcategories[sub_cat_i]?.uuid}`)
        } else {
          rootCategories[root_i].subcategories.push({
            ...content.category,
            subcategories: [],
            contents: [content]
          })
          _preExpanded.push(`cat_${content.category?.uuid}`)
        }
        _preExpanded.push(`cat_${rootCategories[root_i].uuid}`)
      } else {
        // If NOT content.category.parent_category is a root category
        // Check if content.category.parent_category.parent_category is a root category
        const root_i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.parent_category?.id)
        if (root_i !== -1) {
          // if root category, then find the subcategory of content.category?.parent_category?.id
          const sub_cat_i = rootCategories[root_i].subcategories.findIndex((cat) => cat.id === content.category?.parent_category?.id)
          // If found the subcategory, then find the sub_subcategory of content.category.id
          if (sub_cat_i !== -1) {
            const sub_sub_cat_i = rootCategories[root_i].subcategories[sub_cat_i].subcategories.findIndex((cat) => cat.id === content.category?.id)
            // If found the sub sub category, then push the contents into sub sub category
            if (sub_sub_cat_i !== -1) {
              rootCategories[root_i].subcategories[sub_cat_i].subcategories[sub_sub_cat_i].contents.push(content)
            } else {
              rootCategories[root_i].subcategories[sub_cat_i].subcategories.push({
                ...content.category,
                contents: [content],
                subcategories: []
              })
            }
            _preExpanded.push(`cat_${content.category?.uuid}`)
          } else {
            // If not found the sub sub category, push in sub category
            rootCategories[root_i].subcategories.push({
              ...content.category?.parent_category,
              contents: [],
              subcategories: [
                {
                  ...content.category,
                  contents: [content],
                  subcategories: []
                }
              ]
            })
            _preExpanded.push(`cat_${content.category?.parent_category?.uuid}`)
            _preExpanded.push(`cat_${content.category?.uuid}`)
          }
          _preExpanded.push(`cat_${rootCategories[root_i].uuid}`)
        }
      }
    }
  }
  const _shared_categories = rootCategories.filter((cat) => cat.shared_users.length)
  const _private_categories = rootCategories.filter((cat) => !cat.shared_users.length)
  return { _shared_categories, _private_categories, _preExpanded }
}

export const consoleLog = (error) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(error)
  }
}

export const getTitle = (title = '') => {
  return title || ''
}

export const sliceText = (text, number) => {
  return text?.slice(0, number) + (text?.length > number ? ' ...' : '')
};

export const allowedKeyCodesForShortcut = [
  'KeyA',
  'KeyB',
  'KeyC',
  'KeyD',
  'KeyE',
  'KeyF',
  'KeyG',
  'KeyH',
  'KeyI',
  'KeyJ',
  'KeyK',
  'KeyL',
  'KeyM',
  'KeyN',
  'KeyO',
  'KeyP',
  'KeyQ',
  'KeyR',
  'KeyS',
  'KeyT',
  'KeyU',
  'KeyV',
  'KeyW',
  'KeyX',
  'KeyY',
  'KeyZ',
  'Digit1',
  'Digit2',
  'Digit3',
  'Digit4',
  'Digit5',
  'Digit6',
  'Digit7',
  'Digit8',
  'Digit9',
  'Digit0',
  'Numpad1',
  'Numpad2',
  'Numpad3',
  'Numpad4',
  'Numpad5',
  'Numpad6',
  'Numpad7',
  'Numpad8',
  'Numpad9',
  'Numpad0',
  'NumpadMultiply',
  'NumpadAdd',
  'NumpadSubtract',
  'NumpadDecimal',
  'NumpadDivide',
  'NumpadDivide',
  'Semicolon',
  'Equal',
  'Comma',
  'Minus',
  'Period',
  'Slash',
  'Backquote',
  'Backslash',
  'BracketRight',
  'Quote',
  'Slash'
]
